// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import RankTier from "./rank_tier_type";


export default __t.row({
  userId: __t.u64().primaryKey().name("user_id"),
  get tier() {
    return RankTier;
  },
  eloAtAssignment: __t.i32().name("elo_at_assignment"),
  assignedAt: __t.u64().name("assigned_at"),
  plazaRank: __t.u32().name("plaza_rank"),
  username: __t.option(__t.string()),
  rpAtAssignment: __t.i32().name("rp_at_assignment"),
});
